"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const iconoir_react_1 = require("iconoir-react");
// import app components
const layout_1 = __importDefault(require("../../combinations/layout"));
const menuTree_1 = __importDefault(require("../../combinations/menuTree"));
const select_1 = __importDefault(require("../../elements/select"));
const typography_1 = __importDefault(require("../../elements/typography"));
const textarea_1 = __importDefault(require("../../elements/textarea"));
const theme_1 = require("../../../theme");
const copyToClipboard_1 = __importDefault(require("../../../utils/copyToClipboard"));
const Docs = (props) => {
    const { title, content, navigation, pathname, next, versions, activeVersion, linkComponent, header = null, footer = null, documentStyles = {}, sidebarSx = {}, disableCodeFormatting = false, scrollOnPageChange = "container", onChangeVersion, } = props;
    const containerRef = (0, react_1.useRef)(null);
    // Scroll to top of page on page change
    (0, react_1.useEffect)(() => {
        if (!containerRef?.current)
            return;
        if (scrollOnPageChange === "container") {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            containerRef.current.scrollIntoView({ block: "start" });
        }
        else {
            window.scrollTo(0, 0);
        }
    }, [pathname, scrollOnPageChange]);
    // Handle copy to clipboard functionality
    (0, react_1.useEffect)(() => {
        const handleCopyToClipboard = (e) => {
            if (e.target instanceof HTMLElement &&
                e.target.className === "copy-code-button" &&
                // Left mouse key
                e.button === 0) {
                const ngClick = e.target.getAttribute("ng-click");
                const index = ngClick.replace("copyCode(", "").replace(")", "");
                const textarea = document.getElementById(`text-code-${index}`);
                (0, copyToClipboard_1.default)(textarea.value, () => {
                    const button = e.target;
                    const copy = button.querySelector(".fa-clipboard");
                    const check = button.querySelector(".fa-check");
                    copy.style.display = "none";
                    check.style.display = "block";
                    setTimeout(() => {
                        copy.style.display = "block";
                        check.style.display = "none";
                    }, 2000);
                });
            }
        };
        const addRemoveEventListener = () => {
            if (typeof window !== "undefined") {
                window.addEventListener("mousedown", handleCopyToClipboard);
                return () => {
                    window.removeEventListener("mousedown", handleCopyToClipboard);
                };
            }
        };
        addRemoveEventListener();
    }, []);
    return (react_1.default.createElement(layout_1.default, { sidebarLeftSx: sidebarSx, sidebarLeft: react_1.default.createElement(material_1.Box, { sx: { p: 3 } },
            Array.isArray(versions) && versions.length > 0 && (react_1.default.createElement(select_1.default, { label: "Version", onChange: onChangeVersion, value: activeVersion, sx: { mb: 3 } }, versions.map((o) => (react_1.default.createElement(material_1.MenuItem, { key: o.version, value: o.version }, o.title))))),
            Array.isArray(navigation) &&
                navigation.map((tree, i) => react_1.default.createElement(menuTree_1.default, { key: i, tree: tree, slug: pathname, linkComponent: linkComponent }))) },
        react_1.default.createElement(material_1.Container, { ref: containerRef, maxWidth: "md", sx: { px: 0, py: { xs: 0.5, sm: 2, md: 5 } } },
            header,
            title && (react_1.default.createElement(typography_1.default, { variant: "h1", gutterBottom: true }, title)),
            content && (react_1.default.createElement(material_1.Box, { sx: {
                    code: { background: theme_1.colors.secondary[800], color: "#fff", padding: "2px 4px" },
                    pre: {
                        display: "flex",
                        m: 0,
                        padding: "1em",
                        background: theme_1.colors.secondary[900],
                        overflow: "auto",
                        scrollbarColor: theme_1.colors.secondary[900],
                        "::-webkit-scrollbar": { height: "8px" },
                        "::-webkit-scrollbar-track": { background: theme_1.colors.secondary[900], borderRadius: "4px" },
                        "::-webkit-scrollbar-thumb": { background: theme_1.colors.secondary[600], borderRadius: "4px" },
                        borderRadius: "10px",
                        code: {
                            display: "block",
                            background: theme_1.colors.secondary[900],
                        },
                        ".cm-variable,  .highlight .nb": { color: "#0aad8d" },
                        ".cm-builtin,  .cm-property,  .cm-keyword": { color: "#1084d6" },
                    },
                    ...documentStyles,
                } },
                react_1.default.createElement(textarea_1.default, { linkComponent: linkComponent, disableCodeFormatting: disableCodeFormatting }, content))),
            next?.pages && next.pages.length > 0 && (react_1.default.createElement(material_1.Box, { sx: { py: 4 } },
                react_1.default.createElement(material_1.Box, { sx: { mb: 2, display: "flex" } },
                    react_1.default.createElement(typography_1.default, { variant: "h3", gutterBottom: true }, "Next Topics:"),
                    next.description && react_1.default.createElement(typography_1.default, null, next.description)),
                react_1.default.createElement(material_1.Stack, { spacing: 2 }, next.pages.map((o, i) => {
                    return (react_1.default.createElement(material_1.Link, { key: i, component: linkComponent, href: o.slug, variant: "button", underline: "hover", sx: {
                            display: "flex",
                            alignItems: "center",
                        } },
                        o.name,
                        react_1.default.createElement(iconoir_react_1.NavArrowRight, { style: { color: theme_1.colors.white[900] } })));
                }))))),
        footer));
};
exports.default = Docs;
